import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ApprovedGoodsLoanLayer from "../../../components/Admin/ApprovedGoodsLoanLayer";

const ApprovedGoodsLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ApprovedGoodsLoanLayer />
      </MasterLayout>
    </>
  );
};

export default ApprovedGoodsLoan